import { MachineOption } from 'types';

export const sortMachines = (
  machines:
    | (MachineOption & {
        machineGroupId: string;
      })[]
    | null
    | undefined
) => {
  const reA = /[^a-zA-Z]/g;
  const reN = /[^0-9]/g;
  return machines?.sort((a, b) => {
    const aA = a.label.replace(reA, '');
    const bA = b.label.replace(reA, '');
    if (aA === bA) {
      const aN = parseInt(a.label.replace(reN, ''), 10);
      const bN = parseInt(b.label.replace(reN, ''), 10);
      // eslint-disable-next-line no-nested-ternary
      return aN === bN ? 0 : aN > bN ? 1 : -1;
    }
    return aA > bA ? 1 : -1;
  });
};
